import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableEnginCreatePage } from '../../Pages/Engins/EnginCreate/LoadableEnginCreatePage';
import { LoadableEnginDetailsPage } from '../../Pages/Engins/EnginDetails/LoadableEnginDetailsPage';
import { LoadableListEnginPage } from '../../Pages/Engins/ListEngin/LoadableListEnginPage';

const getListEnginRoute = (props: object): AppRouteType => ({
    id: AppRoutes.ENGIN_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.ENGIN_LIST,
        component: LoadableListEnginPage,
        ...props,
    },
});

const getCreateEnginRoute = (props: object): AppRouteType => ({
    id: AppRoutes.ENGIN_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.ENGIN_CREATE,
        component: LoadableEnginCreatePage,
        ...props,
    },
});

const getDetailsEnginRoute = (props: object): AppRouteType => ({
    id: AppRoutes.ENGIN_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.ENGIN_DETAILS,
        component: LoadableEnginDetailsPage,
        ...props,
    },
});

export const getEnginRoutes = (args: object) => [
    getListEnginRoute(args),
    getCreateEnginRoute(args),
    getDetailsEnginRoute(args),
];
